module.exports = __webpack_public_path__ + "static/media/5.5b2e1b46.png";